<template>
    <DefaultLayout :title="modelNamePlural">
       
        <template #title>{{ modelNamePlural }}</template>
        <template #titleNav>
            <CreateNewButton :href="createRoute" v-if="createRoute" />
        </template>

        <template #default>
            
            <slot></slot>
            
        </template>
        
    </DefaultLayout>
</template>

<script>
    export default {
        props: {
            createRoute: String,
            modelNamePlural: String,
        },
    }
</script>